var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"correlation-chart",attrs:{"no-body":""}},[_c('b-card-body',[(_vm.chart)?_c('img',{attrs:{"src":_vm.chart,"alt":""}}):_c('EmptyChart',{attrs:{"description":_vm.$t('tips_correlation')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }